import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PreCasInterviewPage4, { IProps } from './index';

const mapStateToProps = (state: ApplicationState): IProps => {
  const defaultValues = {
    liveWhileStudying: '',
    liveWhileStudyingOther: '',
    expectedWeeklyRent: 0,
    commutePlan: '',
    expectedLivingExpenses: 0,
    awareOfUKVIInterview: undefined,
  };

  const {
    liveWhileStudying,
    liveWhileStudyingOther,
    expectedWeeklyRent,
    commutePlan,
    expectedLivingExpenses,
    awareOfUKVIInterview,
  } = { ...defaultValues, ...state.student.preCasInterview };

  const complete =
    liveWhileStudying !== '' &&
    (liveWhileStudying === 'Other' ? liveWhileStudyingOther !== '' : true) &&
    Number(expectedWeeklyRent) > 0 &&
    commutePlan !== '' &&
    Number(expectedLivingExpenses) > 0 &&
    awareOfUKVIInterview !== undefined;

  return {
    complete,
    currentStep: 4,
    steps: 4,
    liveWhileStudying,
    liveWhileStudyingOther,
    expectedWeeklyRent,
    commutePlan,
    expectedLivingExpenses,
    awareOfUKVIInterview,
  };
};

export default connect(mapStateToProps)(PreCasInterviewPage4);
